import { ApiClient } from '~/apiClients/ApiClient';
import {
  SoftwareAttributes,
  Software,
  SoftwareCreationAttributes,
  SoftwareUpdateAttributes,
} from '~/models/Software';
import { SoftwareTrackerCreationAttributes } from '~/models/SoftwareTracker';

export default class SoftwareApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/software';

  public async provideSoftware(withTaggingPlans: boolean = false): Promise<Array<Software>> {
    const response = await this.get(this.BASE_URL, {
      withTaggingPlans
    });
    return response.data.map((attributes: SoftwareAttributes) => new Software(attributes));
  }

  public async provideSoftwareById(id: number): Promise<Software> {
    const response = await this.get(this.BASE_URL + `/${id}`);
    return new Software(response.data);
  }

  public async createSoftwareTracker(attributes: SoftwareTrackerCreationAttributes) {
    return await this.post(this.BASE_URL, attributes);
  }

  public async createSoftware(attributes: SoftwareCreationAttributes): Promise<Software> {
    const response = await this.post(this.BASE_URL, attributes);
    return new Software(response.data);
  }

  public async updateSoftware(attributes: SoftwareUpdateAttributes): Promise<Software> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new Software(response.data);
  }

  public async deleteSoftware(id: number) {
    return this.delete(this.BASE_URL, {id});
  }
}

